import { create } from 'zustand';

import { ApiUtils } from '@shared/utils';
import { CardsApi } from '@shared/api/rest';

import { GetCardsResponse } from '@shared/api/rest/misc';
import { RequestStrategyEnum } from '@shared/api/rest/models';

interface CardsType {
  data: GetCardsResponse[];
  loading: boolean;
  error: string | null;
  success: boolean | null;
  get: (signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useGetCardsStore = create<CardsType>((set) => ({
  data: [],
  loading: false,
  error: null,
  success: null,

  get: ApiUtils.wrapperApi(async (signal) => {
    try {
      set({ loading: true, error: null, success: null });
      const result = await CardsApi.getCards(signal);
      set({ data: result?.data ?? [], loading: false, success: true });
    } catch (error) {
      set({ error: ApiUtils.getApiError(error), loading: false, success: false });
      throw error;
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ data: [], loading: false, error: null, success: null }),
}));
